import {Box, Button, Divider, Modal, ModalProps, Text, Textarea} from "@mantine/core";
import {CompanyEntity, companyType, firstOrUndefined} from "@ots-frontend/ots-data";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {TruckCompanySelect} from "../../select/entity/CompanySelect/TruckCompanySelect";

export interface DispatchRequestReassignModalProps extends Omit<ModalProps, "onSubmit"> {
    loading?: boolean
    onSubmit?: (company: CompanyEntity, comments: string) => void
}

export const DispatchRequestReassignModal = (props: DispatchRequestReassignModalProps) => {
    const {
        loading = false,
        onSubmit,
        ...rest
    } = props;

    const [selectedCompany, setSelectedCompany] = useState<CompanyEntity | undefined>(undefined)
    const [comments, setComments] = useState<string | undefined>(undefined)

    const {t} = useTranslation(["common"]);

    return (
        <Modal {...rest}>
            <Box>
                <Text size="sm">
                    {t("profile.dispatchrequest.action.reassign.alert.message", "Are you sure you want to reassign this dispatch request?")}
                </Text>
                <Divider/>
                <TruckCompanySelect
                    p="sm"
                    mt="md"
                    placeholder={t<string>(companyType.truckCompany.displayValue.id, companyType.truckCompany.displayValue.defaultMessage)}
                    label={t(companyType.truckCompany.displayValue.id, companyType.truckCompany.displayValue.defaultMessage)}
                    withinPortal={true}
                    clearable={true}
                    withAsterisk={true}
                    required={true}
                    onEntityChange={e => setSelectedCompany(firstOrUndefined(e))}/>
                <Textarea
                    p="sm"
                    placeholder={t<string>("common.entity.message.modal.new.placeholder", "Comments")}
                    label={t("common.entity.message.modal.new.placeholder", "Comments")}
                    autosize={true}
                    minRows={4}
                    withAsterisk={true}
                    required={true}
                    onChange={(e) => setComments(e.currentTarget.value)}
                />
                <Button type="submit" color="red" loading={loading} mt="xl" onClick={(e) => {
                    if (onSubmit && selectedCompany && comments) {
                        onSubmit(selectedCompany, comments);
                    }
                }}>
                    {t("common.action.submit")}
                </Button>
            </Box>
        </Modal>
    );
};
